import { types } from "../types";

const AssetAction = {
    getAssetDeviceCache: () => {
        return { type: types.ASSET_CACHE };
    },
    getAssetCacheSuccess: () => {
        return { type: types.ASSET_CACHE_SUCCESS };
    },
    assetDeviceList: () => {
        return { type: types.ASSET_DEVICE_LIST };
    },
    getDeviceCacheSuccess: () => {
        return { type: types.DEVICE_CACHE_SUCCESS };
    },
    createAsset: () => {
        return { type: types.CREATE_ASSET };
    },
    updateAsset: () => {
        return { type: types.UPDATE_ASSET };
    },
    deleteAsset: () => {
        return { type: types.DELETE_ASSET };
    },
    setCurrentLanguage: () => {
        return { type: types.SET_CURRENTLANGUAGE };
    },
    currentAsset: (asset) => {
        return { type: types.Current_ASSET, asset };
    },
    setBreadcrumbList: (asset) => {
        return { type: types.SET_BREADCRUMB_LIST,asset };
    },
    breadcrumbList: (breadcrumbList) => {
        return { type: types.BREADCRUMB_LIST ,breadcrumbList};
    }
};

export default AssetAction;